const actions = {
  GET_ALL_SYMBOL_BEGIN: 'GET_ALL_SYMBOL_BEGIN',
  GET_ALL_SYMBOL_SUCCESS: 'GET_ALL_SYMBOL_SUCCESS',
  GET_ALL_SYMBOL_ERR: 'GET_ALL_SYMBOL_ERR',

  SET_ALL_SYMBOL_BEGIN: 'SET_ALL_SYMBOL_BEGIN',
  SET_ALL_SYMBOL_SUCCESS: 'SET_ALL_SYMBOL_SUCCESS',
  SET_ALL_SYMBOL_ERR: 'SET_ALL_SYMBOL_ERR',

  getAllSymbolBegin: () => {
    return {
      type: actions.GET_ALL_SYMBOL_BEGIN,
    };
  },

  getAllSymbolSuccess: data => {
    return {
      type: actions.GET_ALL_SYMBOL_SUCCESS,
      data,
    };
  },

  getAllSymbolErr: err => {
    return {
      type: actions.GET_ALL_SYMBOL_ERR,
      err,
    };
  },

  setAllSymbolBegin: () => {
    return {
      type: actions.SET_ALL_SYMBOL_BEGIN,
    };
  },

  setAllSymbolSuccess: data => {
    return {
      type: actions.SET_ALL_SYMBOL_SUCCESS,
      data,
    };
  },

  setAllSymbolErr: err => {
    return {
      type: actions.SET_ALL_SYMBOL_ERR,
      err,
    };
  },
};

export default actions;
